import {
  CANCEL_PLAN,
  GET_SUBSCRIPTION_PLAN,
  GET_SUBSCRIPTION_PLAN_FAILURE,
  GET_SUBSCRIPTION_PLAN_SUCCESS,
  PAUSE_SUBSCRIPTION,
  PAUSE_SUBSCRIPTION_FAILURE,
  PAUSE_SUBSCRIPTION_SUCCESS,
  UPDATE_SUBSCRIPTION_PLAN,
  UPDATE_SUBSCRIPTION_PLAN_FAILURE,
  UPDATE_SUBSCRIPTION_PLAN_SUCCESS,
  SUBSCRIPTION_FEEDBACK_REQUEST,
  SUBSCRIPTION_FEEDBACK_SUCCESS,
  SUBSCRIPTION_FEEDBACK_FAILURE,
  CREATE_BILLING_CHECKOUT,
  CREATE_BILLING_CHECKOUT_SUCCESS,
  CREATE_BILLING_CHECKOUT_FAILURE,
  APPLY_BILLING_PLAN_CHANGE,
  APPLY_BILLING_PLAN_CHANGE_SUCCESS,
  APPLY_BILLING_PLAN_CHANGE_FAILURE,
  CREATE_BILLING_PORTAL_SESSION,
  CREATE_BILLING_PORTAL_SESSION_SUCCESS,
  CREATE_BILLING_PORTAL_SESSION_FAILURE,
  GET_BILLING_PLANS,
  GET_BILLING_PLANS_SUCCESS,
  GET_BILLING_PLANS_FAILURE,
} from "../../utils/constants";

import { createNotification } from "../../utils/notificationManager";
import { getPlanName } from "../../utils/helpers";

function normalizeSubscriptionPlan(plan) {
  if (!plan) {
    return null;
  }

  const isBilling = plan.is_billing === true;
  const provider = isBilling ? "billing" : "classic";
  const paymentInformation = plan.payment_information || {};
  const billingPriceId = paymentInformation.price_id || plan.paddle_plan_id;
  const scheduledChange = paymentInformation.scheduled_change || null;
  const normalizedStatus = plan.status === "deleted" ? "canceled" : plan.status;
  const classicActions = {
    can_change_plan: true,
    can_pause: true,
    can_resume: true,
    can_cancel: true,
    can_update_payment_method: true,
    blocked_reason: null,
  };
  const billingActions = {
    can_change_plan: normalizedStatus !== "canceled",
    can_pause: false,
    can_resume: false,
    can_cancel: false,
    can_update_payment_method: false,
    blocked_reason: null,
  };

  return {
    ...plan,
    provider,
    is_billing: isBilling,
    is_active: Boolean(plan.is_active),
    plan_name: plan.plan_name || getPlanName(billingPriceId || plan.price_id),
    unit_price: plan.unit_price,
    currency: plan.currency,
    paddle_plan_id: plan.paddle_plan_id || billingPriceId,
    price_id: isBilling ? billingPriceId : plan.price_id,
    scheduled_change: isBilling ? scheduledChange : plan.scheduled_change,
    next_billed_at: isBilling
      ? paymentInformation.next_billed_at
      : plan.next_billed_at,
    cancellation_effective_date:
      plan.cancellation_effective_date ||
      paymentInformation.cancellation_effective_date ||
      null,
    management_url: plan.management_url || plan.update_url || null,
    status: normalizedStatus,
    actions: {
      ...(isBilling ? billingActions : classicActions),
      ...(isBilling ? {} : plan.actions),
    },
  };
}

export const handleGetSubscriptionPlanRequest = (state, action) => {
  const isSilentRefetch = Boolean(action?.payload?.silent);

  return {
    ...state,
    isLoading: isSilentRefetch ? state.isLoading : true,
    redirect: false,
  };
};

export const handleGetSubscriptionPlanRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200) {
    return {
      ...state,
      isLoading: false,
      redirect: false,
      myPlan: normalizeSubscriptionPlan(data.data),
    };
  }
  return {
    ...state,
    isLoading: false,
    redirect: false,
  };
};

export const handleGetSubscriptionPlanRequestFailure = (state) => {
  const token = localStorage.getItem("access_token");
  if (token === null) {
    return {
      ...state,
      isLoading: false,
      redirect: true,
      data: null,
    };
  }

  return {
    ...state,
    isLoading: false,
    redirect: false,
    myPlan: null,
  };
};

export const handleUpdateSubscriptionPlanRequest = (state) => {
  return {
    ...state,
    isLoading: true,
    redirect: false,
  };
};

export const handleUpdateSubscriptionPlanRequestSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  if (data.status === 200 && !data?.data?.error?.success) {
    createNotification("warning", data?.data?.error?.error?.message, 2000);
  }
  return {
    ...state,
    isLoading: false,
    redirect: false,
    myPlan: normalizeSubscriptionPlan({
      ...state.myPlan,
      paddle_plan_id: data?.data?.response?.plan_id,
      unit_price: data?.data?.response?.next_payment?.amount,
    }),
  };
};

export const handleUpdateSubscriptionPlanRequestFailure = (state) => {
  createNotification("warning", "Please try again later", 2000);
  return {
    ...state,
    isLoading: false,
    redirect: false,
  };
};

export const handleCancelSubscriptionPlanRequest = (state) => {
  return {
    ...state,
    isLoading: true,
    redirect: false,
    myPlan: normalizeSubscriptionPlan({
      ...state.myPlan,
      status: "canceled",
    }),
  };
};

export const handlePauseSubscriptionReqest = (state) => {
  return {
    ...state,
    isLoading: true,
    redirect: false,
  };
};

export const handlePauseSubscriptionSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;
  let updatedState = {
    ...state,
    isLoading: false,
    redirect: false,
  };

  if (data?.data?.error?.error?.message) {
    createNotification("warning", data?.data?.error?.error?.message, 2000);
  } else {
    updatedState = {
      ...updatedState,
      myPlan: normalizeSubscriptionPlan({
        ...state.myPlan,
        status:
          data?.data?.status === "active" ? "active" : state.myPlan?.status,
        payment_information: {
          ...state.myPlan?.payment_information,
          paused_at:
            data?.data?.status === "paused"
              ? new Date().toLocaleDateString()
              : null,
          paused_from:
            data?.data?.status === "paused"
              ? state?.myPlan?.payment_information?.next_payment?.date
              : null,
        },
      }),
    };
  }
  return updatedState;
};

export const handlePauseSubscriptionfailure = (state) => {
  return {
    ...state,
    isLoading: false,
    redirect: false,
  };
};

export const handleSubscriptionFeedbackRequest = (state) => {
  return {
    ...state,
    isLoading: true,
    redirect: false,
  };
};

export const handleSubscriptionFeedbackSuccess = (state, action) => {
  const {
    payload: { data },
  } = action;

  if (data?.status === 200) {
    createNotification("success", "Thank you for your feedback!", 3000);
  }

  return {
    ...state,
    isLoading: false,
    redirect: false,
  };
};

export const handleSubscriptionFeedbackFailure = (state) => {
  createNotification("error", "Failed to submit feedback. Please try again.", 3000);
  return {
    ...state,
    isLoading: false,
    redirect: false,
  };
};

export const handleCreateBillingCheckoutRequest = (state) => {
  return {
    ...state,
    billingCheckoutLoading: true,
    billingCheckoutError: null,
  };
};

export const handleCreateBillingCheckoutSuccess = (state) => {
  return {
    ...state,
    billingCheckoutLoading: false,
    billingCheckoutError: null,
  };
};

export const handleCreateBillingCheckoutFailure = (state, action) => {
  const error =
    action?.payload?.response?.data?.message ||
    action?.payload?.response?.data?.detail ||
    action?.payload?.message ||
    "Unable to start Paddle Billing checkout";

  return {
    ...state,
    billingCheckoutLoading: false,
    billingCheckoutError: error,
  };
};

export const handleCreateBillingPortalSessionRequest = (state) => {
  return {
    ...state,
    billingPortalSessionLoading: true,
    billingPortalSessionError: null,
  };
};

export const handleCreateBillingPortalSessionSuccess = (state) => {
  return {
    ...state,
    billingPortalSessionLoading: false,
    billingPortalSessionError: null,
  };
};

export const handleCreateBillingPortalSessionFailure = (state, action) => {
  const error =
    action?.payload?.response?.data?.message ||
    action?.payload?.response?.data?.detail ||
    action?.payload?.response?.data?.error ||
    action?.payload?.message ||
    "Unable to open the subscription management portal.";

  return {
    ...state,
    billingPortalSessionLoading: false,
    billingPortalSessionError: error,
  };
};

export const handleGetBillingPlansRequest = (state) => ({
  ...state,
  billingPlans: [],
  billingPlansLoading: true,
  billingPlansError: null,
});

export const handleGetBillingPlansSuccess = (state, action) => ({
  ...state,
  billingPlans: action?.payload?.data || [],
  billingPlansLoading: false,
  billingPlansError: null,
});

export const handleGetBillingPlansFailure = (state, action) => ({
  ...state,
  billingPlans: [],
  billingPlansLoading: false,
  billingPlansError:
    action?.payload?.message ||
    "Billing plans are unavailable. Please try again.",
});

function handleBillingMutationRequest(state, actionType) {
  return {
    ...state,
    billingMutationLoading: true,
    billingMutationError: null,
    billingMutationType: actionType,
  };
}

function handleBillingMutationSuccess(state, action) {
  return {
    ...state,
    billingMutationLoading: false,
    billingMutationError: null,
    billingMutationType: null,
    myPlan: normalizeSubscriptionPlan(action?.payload?.data?.data),
  };
}

function handleBillingMutationFailure(state, action, fallback) {
  const error =
    action?.payload?.response?.data?.message ||
    action?.payload?.response?.data?.detail ||
    action?.payload?.message ||
    fallback;

  return {
    ...state,
    billingMutationLoading: false,
    billingMutationError: error,
    billingMutationType: null,
  };
}

const ACTION_HANDLERS = {
  [GET_SUBSCRIPTION_PLAN]: handleGetSubscriptionPlanRequest,
  [GET_SUBSCRIPTION_PLAN_SUCCESS]: handleGetSubscriptionPlanRequestSuccess,
  [GET_SUBSCRIPTION_PLAN_FAILURE]: handleGetSubscriptionPlanRequestFailure,
  [UPDATE_SUBSCRIPTION_PLAN]: handleUpdateSubscriptionPlanRequest,
  [UPDATE_SUBSCRIPTION_PLAN_SUCCESS]:
    handleUpdateSubscriptionPlanRequestSuccess,
  [UPDATE_SUBSCRIPTION_PLAN_FAILURE]:
    handleUpdateSubscriptionPlanRequestFailure,
  [CANCEL_PLAN]: handleCancelSubscriptionPlanRequest,
  [PAUSE_SUBSCRIPTION]: handlePauseSubscriptionReqest,
  [PAUSE_SUBSCRIPTION_SUCCESS]: handlePauseSubscriptionSuccess,
  [PAUSE_SUBSCRIPTION_FAILURE]: handlePauseSubscriptionfailure,
  [SUBSCRIPTION_FEEDBACK_REQUEST]: handleSubscriptionFeedbackRequest,
  [SUBSCRIPTION_FEEDBACK_SUCCESS]: handleSubscriptionFeedbackSuccess,
  [SUBSCRIPTION_FEEDBACK_FAILURE]: handleSubscriptionFeedbackFailure,
  [CREATE_BILLING_CHECKOUT]: handleCreateBillingCheckoutRequest,
  [CREATE_BILLING_CHECKOUT_SUCCESS]: handleCreateBillingCheckoutSuccess,
  [CREATE_BILLING_CHECKOUT_FAILURE]: handleCreateBillingCheckoutFailure,
  [CREATE_BILLING_PORTAL_SESSION]: handleCreateBillingPortalSessionRequest,
  [CREATE_BILLING_PORTAL_SESSION_SUCCESS]: handleCreateBillingPortalSessionSuccess,
  [CREATE_BILLING_PORTAL_SESSION_FAILURE]: handleCreateBillingPortalSessionFailure,
  [GET_BILLING_PLANS]: handleGetBillingPlansRequest,
  [GET_BILLING_PLANS_SUCCESS]: handleGetBillingPlansSuccess,
  [GET_BILLING_PLANS_FAILURE]: handleGetBillingPlansFailure,
  [APPLY_BILLING_PLAN_CHANGE]: (state) =>
    handleBillingMutationRequest(state, "change-plan"),
  [APPLY_BILLING_PLAN_CHANGE_SUCCESS]: handleBillingMutationSuccess,
  [APPLY_BILLING_PLAN_CHANGE_FAILURE]: (state, action) =>
    handleBillingMutationFailure(
      state,
      action,
      "Unable to update the billing plan."
    ),
};

const initialState = {
  isLoading: false,
  redirect: false,
  myPlan: null,
  billingCheckoutLoading: false,
  billingCheckoutError: null,
  billingPortalSessionLoading: false,
  billingPortalSessionError: null,
  billingMutationLoading: false,
  billingMutationError: null,
  billingMutationType: null,
  billingPlans: [],
  billingPlansLoading: false,
  billingPlansError: null,
};

export default function subscriptionReducer(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}
